export const BRANDED_BACKGROUND_COLOR = "#272020"; // Dark gray
export const BRANDED_PRIMARY_COLOR = "#E22D1B"; // HOTH red
export const BRANDED_SECONDARY_COLOR = "#1895FD"; // HOTH blue
export const BRANDED_LINK_COLOR = "#1895FD"; // HOTH blue

export const WHITELABEL_DEFAULT_BACKGROUND_COLOR = "#f7f7f7"; // Light gray
export const WHITELABEL_DEFAULT_BUTTON_COLOR = "#1895FD"; // Light blue
export const WHITELABEL_DEFAULT_LINKS_COLOR = "#1895FD"; // Light blue
